import { render, staticRenderFns } from "./releGoods.vue?vue&type=template&id=7bb38115&scoped=true&"
import script from "./releGoods.vue?vue&type=script&lang=js&"
export * from "./releGoods.vue?vue&type=script&lang=js&"
import style0 from "./releGoods.vue?vue&type=style&index=0&id=7bb38115&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb38115",
  null
  
)

component.options.__file = "releGoods.vue"
export default component.exports